<template>
    <div>
        <v-menu :close-on-content-click="false" elevation="1">
            <template v-slot:activator="{ props }">
                <v-btn-icon
                    icon="$label_outline"
                    v-bind="props"
                    class="mr-3"
                    :disabled="disableActivator"
                />
            </template>
            <v-card width="300px" elevation="2">
                <v-row no-gutters>
                    <v-col cols="12" class="pa-2 d-flex justify-center disabled">
                        <v-text-field-filled
                            v-model="search"
                            outlined
                            hide-details
                            label="Rechercher"
                            :persistent-hint="true"
                            density="compact"
                            append-inner-icon="$fa-search"
                            clearable
                            @click:clear="search = ''"
                        />
                    </v-col>
                    <v-col cols="12" class="px-2">
                        <v-virtual-scroll
                            bench="5"
                            :items="filteredAllCompanyWithPrimaryLogTags"
                            height="300"
                            class="pb-0"
                            style="overflow-x: hidden"
                        >
                            <template v-slot:default="{ item: tag }">
                                <v-row v-if="!tag.header">
                                    <v-col cols="2">
                                        <v-checkbox
                                            v-model="selectedTags"
                                            hide-details
                                            density="compact"
                                            :ripple="false"
                                            :indeterminate="isIndeterminate(tag.id)"
                                            class="mt-0 pt-0"
                                            @change="statusChange(tag.id)"
                                            :value="tag.id"
                                        />
                                    </v-col>
                                    <v-col cols="9" class="d-flex align-center">
                                        <v-chip
                                            label
                                            :color="tag.color"
                                            variant="flat"
                                            size="small"
                                        >
                                            {{ getTagNameToSelect(tag) }}
                                        </v-chip>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-2 mb-2" v-else>
                                    <v-col cols="1" />
                                    <v-col cols="9">
                                        {{ tag.header }}
                                    </v-col>
                                </v-row>
                            </template>
                        </v-virtual-scroll>
                    </v-col>
                    <v-col cols="12" class="py-1">
                        <div v-if="!isAccountingLine" class="d-flex justify-center">
                            <v-btn @click="updateTags" size="small" variant="text">
                                Appliquer
                            </v-btn>
                        </div>
                        <div v-else>
                            <div class="pl-4">
                                <v-checkbox
                                    label="Appliquer les tags au justificatif ?"
                                    v-model="isApplyUpward"
                                    class="small-label"
                                    dense
                                >
                                </v-checkbox>
                            </div>
                            <div class="d-flex justify-center">
                                <v-btn @click="updateTags" size="small" variant="text">
                                    Appliquer
                                </v-btn>
                            </div>
                            <!-- <v-btn
                                text
                                 size="small"
                                color="primary"
                                @click="updateTags"
                            >
                                Appliquer
                            </v-btn> -->
                        </div>
                    </v-col>
                </v-row>
            </v-card>
        </v-menu>
        <template v-for="(sb, index) of snackbars" :key="index">
            <v-snackbar
                @update:model-value="deleteSnackbar(index)"
                :timeout="15000"
                :style="'margin-top: ' + (getNumberOfDisplayedSnackBar(index) + 1) * 56 + 'px'"
                :model-value="sb.display"
                location="end"
            >
                <strong>{{ getSnackbarText(sb) }}</strong>

                <template #actions>
                    <v-btn @click.stop="createSuggestion(sb)" variant="text"> Appliquer </v-btn>
                    <v-btn-icon icon="$oss-close" size="small" @click.stop="sb.display = false" />
                </template>
            </v-snackbar>
        </template>
    </div>
</template>

<script lang="ts">
import _ from "lodash";
import { uniqBy } from "lodash";

import TAGS_DOCUMENTS from "../../graphql/document/TagsDocuments.gql";
import TAGS_BANKTRANSACTIONS from "@/graphql/bankTransaction/TagsBankTransactions.gql";
import TAGS_ACCOUNTINGLINES from "@/graphql/accountingLine/TagsAccountingLines.gql";
import UPDATE_DOCUMENTS_TAGS from "@/graphql/document/UpdateDocumentsTags.gql";
import UPDATE_BANK_TRANSACTION_TAGS from "../../graphql/document/UpdateBankTransactionsTags.gql";
import UPDATE_ACCOUNTING_LINE_TAGS from "@/graphql/accountingLine/UpdateAccountingLinesTags.gql";

import { FreeTagBase } from "./FreeTagBase";
import { Component, toNative } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

@Component({
    emits: ["selected-tags"],
})
export class MultipleFreeTagging extends FreeTagBase {
    isApplyUpward = false;

    search = "";

    get selectedCompany() {
        return this.$store.state.selected_company;
    }

    get allTags() {
        return this.filteredCompanyTags.filter((x) => x.id && x.type !== "SubAccountableAccount");
    }

    get filteredTags() {
        if (this.search) {
            return this.allTags.filter(
                (x) => x.header || x.text.toLowerCase().startsWith(this.search.toLowerCase()),
            );
        }
        return this.allTags;
    }

    get disableActivator() {
        return (
            !this.selectedDocuments?.length &&
            !this.selectedBankTransactions?.length &&
            !this.selectedAccountingLines?.length
        );
    }

    @Watch("selectedDocuments")
    @Watch("selectedBankTransactions")
    @Watch("selectedAccountingLines")
    async updateSelectedTags() {
        if (this.selectedDocuments?.length) {
            const result = await this.$apollo.query({
                query: TAGS_DOCUMENTS,
                variables: {
                    companyId: this.selectedCompany.id,
                    ids: this.selectedDocuments.map((sd) => sd.id),
                },
            });
            this.selectedTags = [];
            this.indeterminateTags = [];
            const tags = result.data.documents.flatMap((document) =>
                document.tags.map((tag) => tag.id),
            );
            const countTags = _.countBy(tags);
            for (const tag in countTags) {
                if (countTags[tag] === this.selectedDocuments?.length) {
                    this.selectedTags.push(tag);
                } else {
                    this.indeterminateTags.push(tag);
                }
            }
            await this.updateModel();
        }
        if (this.selectedBankTransactions?.length) {
            const result = await this.$apollo.query({
                query: TAGS_BANKTRANSACTIONS,
                variables: {
                    companyId: this.selectedCompany.id,
                    ids: this.selectedBankTransactions.map((sd) => sd.id),
                },
            });
            this.selectedTags = [];
            this.indeterminateTags = [];
            const tags = result.data.bankTransactions.flatMap((bankTransaction) =>
                bankTransaction.tags.map((tag) => tag.id),
            );
            const countTags = _.countBy(tags);
            for (const tag in countTags) {
                if (countTags[tag] === this.selectedBankTransactions?.length) {
                    this.selectedTags.push(tag);
                } else {
                    this.indeterminateTags.push(tag);
                }
            }
            await this.updateModel();
        }
        if (this.selectedAccountingLines?.length) {
            this.selectedTags = [];
            this.indeterminateTags = [];
            const ids = this.selectedAccountingLines
                .filter((sd) => !!sd.accountingLineId)
                .map((sd) => sd.accountingLineId);
            if (ids?.length) {
                const result = await this.$apollo.query({
                    query: TAGS_ACCOUNTINGLINES,
                    variables: {
                        companyId: this.selectedCompany.id,
                        ids: this.selectedAccountingLines.map((sd) => sd.accountingLineId),
                    },
                });

                const tags = result.data.getAccountingLinesTags.tags.flatMap((accountingLine) =>
                    accountingLine.tags.map((tag) => tag.id),
                );
                const countTags = _.countBy(tags);
                for (const tag in countTags) {
                    if (countTags[tag] === this.selectedAccountingLines?.length) {
                        this.selectedTags.push(tag);
                    } else {
                        this.indeterminateTags.push(tag);
                    }
                }
            }
            await this.updateModel();
        }
    }
    selectedTags = [];
    /*
    @Apollo({
        query: TAGS_BANKTRANSACTIONS,
        variables() {
            return {
                companyId:this.selectedCompany.id,
                ids: this.selectedBankTransactions.map(sd => sd.id)
            }
        },
        skip() {
            return !this.selectedBankTransactions?.length || !this.selectedCompany
        },
        async specificResult({ data, loading }) {
            if (!loading) {
                if (data) {
                    debugger
                    this.selectedTags = []
                    this.indeterminateTags = []
                    this.diselectedTags = []
                    let tags = data.bankTransactions.flatMap(bankTransaction => bankTransaction.tags.map(tag => tag.id))
                    let countTags = _.countBy(tags)
                    for (let tag in countTags) {
                        if (countTags[tag] === this.selectedBankTransactions?.length){
                            this.selectedTags.push(tag)
                        } else {
                            this.indeterminateTags.push(tag)
                        }
                    }
                    await this.updateModel()
                }
            }
        }
    })

    @Apollo({
        query: TAGS_ACCOUNTINGLINES,
        variables() {
            return {
                companyId:this.selectedCompany.id,
                ids: this.selectedAccountingLines.map(sd => sd.id)
            }
        },
        skip() {
            return !this.selectedAccountingLines?.length || !this.selectedCompany
        },
        async specificResult({ data, loading }) {
            if (!loading) {
                if (data) {
                    debugger
                    this.selectedTags = []
                    this.indeterminateTags = []
                    this.diselectedTags = []
                    let tags = data.accountingLine.flatMap(accountingLine => accountingLine.tags.map(tag => tag.id))
                    let countTags = _.countBy(tags)
                    for (let tag in countTags) {
                        if (countTags[tag] === this.selectedAccountingLines?.length){
                            this.selectedTags.push(tag)
                        } else {
                            this.indeterminateTags.push(tag)
                        }
                    }
                    await this.updateModel()
                }
            }
        }
    })
*/
    statusChangedTags = [];

    indeterminateTags = [];

    isIndeterminate = function verifyIfTheTagIDIsInIndeterminatdTagsList(id) {
        return this.indeterminateTags.findIndex((x) => x === id) !== -1;
    };

    statusChange(id) {
        if (this.selectedTags.findIndex((x) => x === id) === -1) {
            this.statusChangedTags = _.uniq([...this.statusChangedTags, id]);
            debugger;
        }
        const partitionTagId = this.filteredAllCompanyTags.at(
            this.filteredAllCompanyTags.findIndex((x) => x.id === id),
        ).partitionTag.id;
        if (partitionTagId !== "WithoutId") {
            for (const tag of this.filteredAllCompanyTags) {
                if (tag.partitionTag.id === partitionTagId && tag.id !== id) {
                    for (let i = 0; i != this.indeterminateTags.length; i += 1) {
                        if (tag.id == this.indeterminateTags[i]) {
                            this.indeterminateTags.splice(i, 1);
                            i -= 1;
                        }
                    }
                    for (let i = 0; i != this.selectedTags.length; i += 1) {
                        if (tag.id == this.selectedTags[i]) {
                            this.selectedTags.splice(i, 1);
                            i -= 1;
                        }
                    }
                }
            }
        }
        debugger;
    }

    //
    // snackbars
    //

    snackbars = [];

    deleteSnackbar(index) {
        this.snackbars[index].display = false;
        const falseLength = this.snackbars.filter((x) => x.display === false).length;
        if (falseLength === this.snackbars.length) {
            this.snackbars = [];
        }
    }

    // addSnackbar() {
    //     this.snackbars.push(true)
    // }

    getNumberOfDisplayedSnackBar(index) {
        const part = this.snackbars.slice(0, index);
        return part.filter((x) => x.display === true).length;
    }

    async updateTags() {
        const disconnectedTags = _.difference(this.statusChangedTags, this.selectedTags);

        // let documentsId = this.selectedDocuments
        const toAddTagsIds: any = this.selectedTags.map((x) => ({ id: x }));
        const toRemoveTagsIds = disconnectedTags.map((x) => ({ id: x }));

        //debugger
        if (this.selectedDocuments?.length) {
            const result = await this.$apollo.mutate({
                mutation: UPDATE_DOCUMENTS_TAGS,
                variables: {
                    ids: this.selectedDocuments.map((sd) => sd.id),
                    toAddTags: toAddTagsIds,
                    toRemoveTags: toRemoveTagsIds,
                    companyId: this.company.id,
                },
            });
            if(result.data?.updateDocumentsTags?.connectedCompanyTags?.length) {
                const { connectedCompanyTags } = result.data.updateDocumentsTags;
                //debugger
                this.snackbars.push(...this.formatSnackbarTags(connectedCompanyTags));
            } else {
                debugger
            }
        }
        if (this.selectedBankTransactions?.length) {
            const result = await this.$apollo.mutate({
                mutation: UPDATE_BANK_TRANSACTION_TAGS,
                variables: {
                    ids: this.selectedBankTransactions.map((sd) => sd.id),
                    toAddTags: toAddTagsIds,
                    toRemoveTags: toRemoveTagsIds,
                    companyId: this.company.id,
                },
            });
            console.log(result)
            if(result.data?.updateBankTransactionsTags?.connectedCompanyTags?.length) {
                const { connectedCompanyTags } = result.data.updateBankTransactionsTags;
                //debugger
                this.snackbars.push(...this.formatSnackbarTags(connectedCompanyTags));
            } else {
                debugger
            }
        }
        if (this.selectedAccountingLines?.length) {
            debugger;

            const result = await this.$apollo.mutate({
                mutation: UPDATE_ACCOUNTING_LINE_TAGS,
                variables: {
                    ids: this.selectedAccountingLines.map((sd) => sd.accountingLineId),
                    isApplyUpward: this.isApplyUpward,
                    toAddTags: toAddTagsIds,
                    toRemoveTags: toRemoveTagsIds,
                    companyId: this.company.id,
                },
            });
            if(result.data?.updateAccountingLinesTags?.connectedCompanyTags?.length) {
                const { connectedCompanyTags } = result.data.updateAccountingLinesTags;
                this.snackbars.push(...this.formatSnackbarTags(connectedCompanyTags));
            } else {
                debugger
            }
        }

        debugger;
        this.$emit("selected-tags");
    }

    formatSnackbarTags(connectedTags) {
        const thirdPartyCompanies = uniqBy(
            this.selectedDocuments.map((x) => x.thirdPartyCompany),
            "thirdPartyCompany",
        );
        const tagsSelectedId = connectedTags.map((x) => x.id);
        const tags = this.companyTags.filter((ct) => ct.id && tagsSelectedId.includes(ct.id));
        const snackbars = [];
        debugger;
        for (const tag of tags) {
            for (const thirdPartyCompany of thirdPartyCompanies as any[]) {
                if (thirdPartyCompany && thirdPartyCompany.type !== "GENERIC") {
                    if (
                        (tag.type === "External" || tag.type === "TagDistribution") &&
                        !this.thirdPartyCompanyTags.find(
                            (tpct) =>
                                tpct.tag.id === tag.id &&
                                tpct.thirdPartyCompany.id === thirdPartyCompany.id,
                        )
                    ) {
                        snackbars.push({
                            tag: tag,
                            thirdPartyCompany: thirdPartyCompany,
                            loading: false,
                            display: true,
                        });
                    }
                }
            }
        }
        return snackbars;
    }

    isJournalRightType(tag) {
        const Documentstype = [];

        if (this.selectedDocuments) {
            for (const document of this.selectedDocuments) {
                if (Documentstype.findIndex((x) => x === document.type) === -1) {
                    Documentstype.push(document.type);
                }
            }
        }
        if (tag.id) {
            const partitionTag = this.filteredAllCompanyTags.at(
                this.filteredAllCompanyTags.findIndex((x) => x.id === tag.id),
            ).partitionTag;
            const partitionTagId = partitionTag.id;

            if (Documentstype.length != 1 && partitionTagId === "") {
                return false;
            } else if (partitionTagId === "" && partitionTag.primaryLog !== Documentstype.at(0)) {
                return false;
            }
        } else {
            if (Documentstype.length != 1 && tag.partitionTag.id === "") {
                return false;
            } else if (
                tag.partitionTag.id === "" &&
                tag.partitionTag.primaryLog !== Documentstype.at(0)
            ) {
                return false;
            }
        }
        return true;
    }

    get filteredAllCompanyWithPrimaryLogTags() {
        const tags = [];
        const testedTags = this.filteredAllCompanyTags;

        for (const tag of testedTags) {
            if (this.isJournalRightType(tag)) {
                tags.push(tag);
            }
        }
        return tags;
    }

    get isAccountingLine() {
        if (this.selectedAccountingLines) return true;
        return false;
    }
}

export default toNative(MultipleFreeTagging);
</script>

<style>
.small-label .v-label {
    font-size: 10px;
}
</style>
